<div class="story-payment {{config?.theme}}" id="storyPayment">
  <div class="bdaynudge" *ngIf="params?.mini_story === '1' && params?.birthdaytime === '1'">
    <img loading="lazy" [attr.data-src]="'../assets/images/starspng.png'" alt="">
    <div class="content">
      <div class="title">Celebrate your day by saving a life</div>
      <div class="sub">Bring that feeling back by saving a life today!</div>
    </div>
  </div>
  <div class="tax-nudge" *ngIf="params?.mini_story && (params?.birthdaytime !== '1' || params?.mini_story !== '1')">
    <img loading="lazy" [attr.data-src]="'../assets/images/TaxBenefit.png'" alt="">
    <div class="content">Save a life. Save taxes.<br>Contribute now and get 80G tax benefits!</div>
  </div>
  <div *ngIf="config?.topContent" class="top-content d-none d-md-block">
    <div *ngIf="config?.daysLeft && (config?.fundraiser?.end_date | dayjs:'diffInDays') > 0 && (config?.fundraiser?.end_date | dayjs:'diffInDays') < 7 && !config?.fundraiser?.settings?.hidedaysleft"  class="days-left-wrapper">
      <div class="days-left">
        <i class="material-icons">update</i><span>{{config?.fundraiser?.end_date | dayjs:'diffInDays':1}} {{(config?.fundraiser?.end_date | dayjs:'diffInDays':1) > 1 ? 'Days Left' : 'Day Left'}}!</span>
      </div>
    </div>

    <div *ngIf="config?.fundraiser?.raised?.backers && config?.supporters" class="supporters">
      <app-supporters-info [fundraiser]="config?.fundraiser"></app-supporters-info>
    </div>

    <div *ngIf="config?.assured" class="ketto-assured">
      <app-ketto-assured-v2></app-ketto-assured-v2>
    </div>
  </div>


  <div class="payment-wrapper">

    <div class="payment-header" *ngIf="config?.header">
      <app-contact-beneficiary [fundraiser]="config?.fundraiser"></app-contact-beneficiary>

      <app-currency-dropdown *ngIf="paymentRef?.contributeDetails?.supported_currency" [currencies]="paymentRef?.contributeDetails?.supported_currency"
                              [selectedCurrency]="paymentRef?.contributeDetails?.selected_currency" (userSelectionCurrency)="setCurrency($event)">
      </app-currency-dropdown>
    </div>

    <app-main-payment [internal]="true"
                      [fundraiser]="config?.fundraiser"
                      [inputFields]="config?.inputFields"
                      [origin]="config?.origin"
                      [showBeneficiary]="config?.showBeneficiary"
                      type="onpage"
                      customTheme="{{config?.enable_sip_switch?'theme-v5':'theme-v2'}}"
                      [skipMobileCheck]="true"
                      [onpage]="true"
                      captchaType="onpage"
                      [paymentIcons]="true"
                      [recommendTag]="true"
                      [paymentHeader]="config?.paymentHeader"
                      [position]="config?.position"
                      [payment_config]="config"
                      #paymentRef>
    </app-main-payment>
  </div>
  <div class="bdaytax-nudge" *ngIf="(params?.mini_story === '1' && params?.birthdaytime === '1')">
    <img loading="lazy" [attr.data-src]="'../assets/images/taxbenefitgray.png'" alt="">
    <div class="content">Contribution to this fundraiser is eligible for 80G Tax Benefits</div>
  </div>
</div>

<div class="ministory_qd" *ngIf="vwo.repeatorder_ministoryAB() && userData">
  <app-payment-otd [InputConfig]="{ label: 'Stories.donations.makeDonation' | translatePipe | async,  fundraiser: config?.fundraiser, position: 9, docked: true, slabTheme: 'slab-theme-v5', paymentBtnClass: 'payment-btn-theme-v3', origin: 's', showSlabs: true, donatingAs: true, optionsCheck: true, onpage: true}"></app-payment-otd>
</div>

